import * as types from './types';

const initialState = {
  // Este estado es para saber si el formulario tiene cambios y se debe mostrar el modal de confirmacion
  dirtyForm: false
};

function formGuardReducer(state = initialState, action) {
  switch (action.type) {
    case types.SET_DIRTY_FORM:
      return {
        ...state,
        dirtyForm: action.payload
      };
    default:
      return state;
  }
}

export { formGuardReducer };
